import { createReducer, Action, on } from '@ngrx/store';
import { loadingAction } from '../actions/loading.action';

export interface GlobalStore {
	loading: boolean;
}

const initialState: GlobalStore = {
	loading: false
};

const _globalReducer = createReducer<GlobalStore, Action>(
	initialState,
	on(loadingAction, (state, action) => ({
		...state,
		loading: action.loading
	})),
);

export function globalReducer(state: GlobalStore = initialState, action: Action) {
	return _globalReducer(state, action);
}
